import { googleLoginUrl } from '@/api/auth';
import './LoginScreen.css';

export default function LoginScreen() {
  return (
    <div className="login-screen">
      <div className="login-card">
        <h1>TOBi</h1>
        <p>Sign in to chat with your Vodacom virtual assistant.</p>
        <a className="google-btn" href={googleLoginUrl()}>
          Sign in with Google
        </a>
      </div>
    </div>
  );
}
